import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { DealerOverviewDashboardQueryKeys } from "modules/DealerOverviewDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { toISOString } from "utils/dateHelperFunctions";

import type { DefaultReportThreshold } from "modules/DealerOverviewDashboard/components/DmsSystem/components/ThresholdSettings/hooks/useListThresholdsQuery";

type UpdateThresholdsPayload = {
  dealer_id: number;
  dealer_report_thresholds: DefaultReportThreshold[];
};

export const useUpdateThresholdsMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: UpdateThresholdsPayload) =>
      (await ApiInstance.post("/dealers/thresholds/update", payload, ENV.reportsBaseURL)).data?.dealer_report_thresholds ?? [],
    onSuccess: payload => {
      const thresholds = typedQueryClient.getQueryData(DealerOverviewDashboardQueryKeys.thresholds(payload.dealer_id));
      if (!thresholds) return;

      const updatedThresholds = thresholds.map(t => {
        const threshold = payload.dealer_report_thresholds.find(tr => tr.dealer_report_column === t.dealer_report_column);
        return { ...t, ...threshold, updated_on: threshold ? toISOString(new Date()) : t.updated_on };
      });

      typedQueryClient.setQueryData(DealerOverviewDashboardQueryKeys.thresholds(payload.dealer_id), updatedThresholds);
    }
  });
